
  export const style={
    inpuStyle:{
      colorInput:"#162748"
    },
    url:{
      urlClient:"https://smartsky.prd.appnoz.com.br/",
      urlClientYouseed:"https://admyouseed.bancosemear.com.br/"
    },
    fileUrl:{
      logo:"https://timcoo-geral.s3.us-east-1.amazonaws.com/Logos/primary_logo_smartsky.png",
      secondaryLogonLogo: "null",
    },
    variables:{
       customMenuItem: true,
       autoRegister: false,
       recaptchaVersion : "V2"
    },
    CurrencyName:{
      name:"SmartCoin/SmartCoins"
    },
    teamName:{
      name:"smartsky"
    },
    hasToken: true,
    hostHeader: "smartsky"
  }
